module.exports = require('../dist/react');
